import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import {Card as MaterialCard, CardHeader, CardContent } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  root:    {
    display: 'flex'
  },
  card:    {
    display:       'flex',
    flexDirection: 'column'
  },
  title:   {
    paddingTop: theme.spacing() * 3
  },
  actions: {
    display:   'flex',
    alignSelf: 'flex-end',
    marginTop: theme.spacing() * 5.6
  }
})

interface MyProps extends StyledProps {
  title: string,
  content: { body, actions }
}

export class CardComponent extends React.Component<MyProps> {
  static defaultProps = {
    title: 'Card Title'
  }

  render() {
    const {classes, className, title, content} = this.props
    return (
      <div className={classNames(classes.root, className)}>
        <MaterialCard className={classes.card} raised>
          <CardHeader className={classes.title} title={title}/>
          <CardContent className={classes.card}>
            <div>{content.body}</div>
            <div className={classes.actions}>
              {content.actions}
            </div>
          </CardContent>
        </MaterialCard>
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class Card extends CardComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Card.tsx